import { createContext } from 'react';
import { CanduPreviewContextType } from '@candulabs/core';

export const PreviewContext = createContext<CanduPreviewContextType>({
  showSegmentPicker: false,
  segmentId: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setShowSegmentPicker: () => {},
});
